<template>
  <div style="width: 1200px;margin: 0 auto;height: 100%" class="xh">
    <el-tabs :tab-position="tabPosition" v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="专家管理办法" name="first">
<!--        <div style="font-size: 18px;font-weight: bold;">{{ waytitle }}</div>-->
<!--        <div style="padding-bottom: 20px;padding-top: 30px;font-size: 14px;text-align: justify;text-indent:2em;line-height: 40px">{{waycontent}}</div>
      -->
        <div class="pa" style="padding-bottom: 20px;font-size: 14px;text-align: justify" v-html="waycontent"></div>
      </el-tab-pane>
      <el-tab-pane label="核心专家" name="second">
        <div style="text-align: left;padding-top: 15px;padding-left: 50px;">
          <div v-for="(item, index) in expertsList.slice((current_page-1)*per_page,current_page*per_page)"  :key="index" @click="viewWebPartner(item.url)" style="padding-bottom: 10px;">
            <router-link :to="{name:'Newsparticulars',query: { id: item.id }}">
              <div style="display: flex;">
            <div>
                <img  class="im" :src="item.img">
            </div>
            <div class="pi">
              <span style="font-size: 18px;color: red">{{ item.name }}</span><br>
              <span style="font-size: 14px;">{{ item.introduction_text }}</span>
            </div>
          </div>
            </router-link>
          </div>


          <!--分页区域-->
          <el-pagination
            style="text-align: center;padding-top: 30px;"
            @size-change="size_change"
            @current-change="current_change"
            :current-page="current_page"
            :page-sizes="[10,20,30]"
            :page-size="per_page"
            layout="total, sizes, prev, pager, next, jumper"
            :total="total">
          </el-pagination>
        </div>
      </el-tab-pane>


      <!--
            <div v-if="username === ''" style="line-height: 60px;border-bottom-color: transparent;color: rgb(255, 255, 255);font-size: 14px">
            <span :class="{'actcss':activeVar===10}"><router-link to="/Login" @click.native="login">登陆</router-link>&nbsp;</span>|<span :class="{'actcss':activeVar===11}">&nbsp;<router-link to="/Register" @click.native="register">注册</router-link></span>
          </div>
          <div v-else style="line-height: 60px;border-bottom-color: transparent;color: rgb(255, 255, 255);font-size: 14px">
            <span style="width: 100px;overflow: hidden;white-space: nowrap;text-overflow: ellipsis;float: left">{{username}}</span><span @click="exit">退出</span>
          </div>
            -->
      <el-tab-pane label="专家入库申请" name="third">
        <div style="line-height: 150px;" v-if="token === ''">请先<router-link to="/Login" style="color: red">登录</router-link></div>
        <div v-else>
        <div style="font-size: 18px;font-weight: bold;padding-bottom: 20px;">注:请先前往专家服务->专家管理办法下载申请表，填写完毕后，在此页面上传JPG、JPEG、PNG、PDF格式的文件</div>
<!--        <div v-for="(item, index) in xzList" :key="index" >
          <div style="padding-bottom: 20px">
&lt;!&ndash;            <el-button  size="mini" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport(item.id,item.filename,item.ty)"><span style="font-size: 14px;">{{item.filename}}</span></el-button>
          &ndash;&gt;
            <el-button  size="mini" class="filter-item" type="primary" icon="el-icon-download" @click="handleExport(item.message)"><span style="font-size: 14px;">{{ item.title }}</span></el-button>
          </div>
        </div>-->
        <div style="margin-right: 120px">
          <el-form
            :rules="rules"
            ref="ruleF"
            :model="ruleForm"
            label-width="120px"
            class="demo-ruleForm"
          >
            <el-form-item label="姓名" prop="name" >
              <el-input v-model="ruleForm.name" placeholder="请输入姓名" style="width: 500px;"></el-input>
            </el-form-item>
            <el-form-item label="头像">
              <el-upload
                class="upimg"
                ref="uploadimg"
                action=""
                list-type="picture-card"
                accept=".jpg,.png,.jpeg"
                :on-remove="handleRemove1"
                :on-change="UploadImage1"
                :limit="1"
                :file-list="fileList1"
                :auto-upload="false"
              >
                <i class="el-icon-plus" style="float: left;line-height: 50px;margin-left: 10px"></i>
                <template #tip>
                  <div style="font-size: 12px;color: #919191;">
                    上传类型:JPG、JPEG、PNG,最大2M
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="dialogVisible1" style="line-height: 0;">
                <img style="width: 100%;height: 100%"  :src="dialogImageUrl1" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item label="简介" prop="introduction" >
              <el-input type="textarea" rows="4" v-model="ruleForm.introduction" placeholder="请输入简介" style="width: 500px;"></el-input>
            </el-form-item>
            <el-form-item label="申请表"  >
              <el-upload
                class="upapply"
                ref="upload"
                action=""
                list-type="picture-card"
                accept=".jpg,.png,.jpeg,.pdf"
                :on-remove="handleRemove"
                :on-change="UploadImage"
                :limit="10"
                :file-list="fileList"
                :auto-upload="false"
              >
                <i class="el-icon-plus"></i>
                <template #tip>
                  <div style="font-size: 12px;color: #919191;">
                    上传类型:JPG、JPEG、PNG、PDF,最大3M
                  </div>
                </template>
              </el-upload>
              <el-dialog v-model="dialogVisible" style="line-height: 0;">
                <img style="width: 100%;height: 100%"  :src="dialogImageUrl" alt="" />
              </el-dialog>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitForm('ruleF')">确定</el-button>
            </el-form-item>
          </el-form>
        </div>
        </div>

       </el-tab-pane>
       <el-tab-pane label="信息报备" name="fourth">
        <div style="width: 500px;">
          <el-form ref="form" :model="form" label-width="100px">
            <el-form-item label="专家姓名" >
              <el-input v-model="form.username"  placeholder="请输入专家姓名"></el-input>
            </el-form-item>
            <el-form-item label="参与时间">
              <el-date-picker
                    style="width: 100%;"
                    v-model="form.time"
                    type="datetime"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    placeholder="请选择参与时间">
                </el-date-picker>

            </el-form-item>
            <el-form-item label="项目类型">
              <el-select v-model="form.type" placeholder="选择项目类型"  style="width: 100%;">
                <el-option label="检查" value="检查"></el-option>
                <el-option label="审查" value="审查"></el-option>
                <el-option label="咨询服务" value="咨询服务"></el-option>
                <!-- <el-option v-for="item in types" :key="item.id" :label="item.type" :value="item.id"></el-option> -->
              </el-select>
            </el-form-item>
            <el-form-item label="项目名称" >
              <el-input v-model="form.name" placeholder="请输入项目名称"></el-input>
            </el-form-item>
            <el-form-item label="参与地点" >
              <el-input v-model="form.addr" placeholder="请输入参与地点"></el-input>
            </el-form-item>
            <el-form-item label="项目方联系人" >
              <el-input v-model="form.lx_user" placeholder="请输入项目方联系人"></el-input>
            </el-form-item>
            <el-form-item label="项目方电话" >
              <el-input v-model="form.tel" placeholder="请输入项目方电话"></el-input>
            </el-form-item>
            <el-form-item label="备注" prop="">
                <el-input type="textarea" placeholder="请输入备注" v-model="form.remarks"></el-input>
            </el-form-item>
            <el-form-item style="width: 300px;" label-width="90px">
              <el-button type="primary" @click="onSubmit">确定</el-button>
              <el-button @click="cance">取消</el-button>
            </el-form-item>
          </el-form>
        </div>
       </el-tab-pane>
      <!-- <el-tab-pane label="信息报备" name="fourth">
        <el-collapse accordion>
          <div>
            <div v-clickoutside="hideReplyBtn" @click="inputFocus" class="my-reply">
              <el-avatar class="header-img" :size="40" :src="head_img"></el-avatar>
              <div class="reply-info" >
                <div
                  tabindex="0"
                  contenteditable="true"
                  id="replyInput"
                  spellcheck="false"
                  placeholder="输入评论..."
                  class="reply-input"
                  @focus="showReplyBtn"
                  @input="onDivInput($event)"
                >
                </div>
              </div>
              <div class="reply-btn-box" v-show="btnShow">
                <el-button class="reply-btn" size="medium" @click="sendComment" type="primary">发布问题</el-button>
              </div>
            </div>
            <div v-for="(item,i) in comments" :key="i" class="author-title reply-father">
              <el-avatar class="header-img" :size="40" :src="item.head_img"></el-avatar>
              <div class="author-info">
                <span class="author-name">{{item.nickname}}</span>
                <span class="author-time">{{item.createtime}}</span>
              </div>
              <div class="icon-btn">
                <span @click="showReplyInput(i,item.nickname,item.userid,item.id)"><i class="iconfont el-icon-s-comment"></i>{{item.commentNum}}</span>

              </div>
              <div class="talk-box">
                <el-collapse-item class="reply" :title="item.comment" :name="i">

                <div class="reply-box">
                  <div v-for="(reply,j) in item.reply" :key="j" class="author-title">
                    <el-avatar class="header-img" :size="40" :src="reply.fromimg"></el-avatar>
                    <div class="author-info">
                      <span class="author-name">{{reply.fromname}}</span>
                      <span class="author-time">{{reply.createtime}}</span>
                    </div>
                    <div class="icon-btn">
                      <span @click="showReplyInput(i,reply.fromname,reply.fromid,item.id)"><i class="iconfont el-icon-s-comment"></i>{{reply.commentNum}}</span>

                    </div>
                    <div class="talk-box">
                      <p>
                        <span>回复 {{reply.nickname}}:</span>
                        <span class="reply">{{reply.comment}}</span>
                      </p>
                    </div>
                    <div class="reply-box">
                    </div>
                  </div>
                </div>
                </el-collapse-item>
              </div>
              <div  v-show="_inputShow(i)" class="my-reply my-comment-reply">
                <el-avatar class="header-img" :size="40" :src="head_img"></el-avatar>
                <div class="reply-info" >
                  <div tabindex="0" contenteditable="true" spellcheck="false" placeholder="输入评论..."   @input="onDivInput($event)"  class="reply-input reply-comment-input"></div>
                </div>
                <div class=" reply-btn-box">
                  <el-button class="reply-btn" size="medium" @click="sendCommentReply(i,j)" type="primary">发表评论</el-button>
                  <el-button class='reply-btn' size="medium" type="warning" round @click="canelCommit(i)">取消</el-button>
                </div>
              </div>

            </div>

          </div>
        //分页区域
          <el-pagination
            style="text-align: center;padding-top: 30px;"
            @size-change="size_change"
            @current-change="current_change"
            :current-page="currentPage"
            :page-sizes="[10,20,30]"
            :page-size="pagesize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="comments.length
            ">
          </el-pagination>
        </el-collapse>
      </el-tab-pane> -->
      <el-tab-pane label="专家库" name="fifth">
<!--        <div style="font-size: 18px;font-weight: bold;">{{ waytitle }}</div>-->
        <!--        <div style="padding-bottom: 20px;padding-top: 30px;font-size: 14px;text-align: justify;text-indent:2em;line-height: 40px">{{waycontent}}</div>
              -->
        <div class="pa" style="padding-bottom: 20px;font-size: 14px;text-align: justify;line-height: 35px" v-html="expertcontent"></div>
      </el-tab-pane>
    </el-tabs>
  </div>

</template>

<script>
import Utils from '../../assets/js/util.js';
const axios = require('axios');
// const clickoutside = {
//   // 初始化指令
//   bind(el, binding, vnode) {
//     function documentHandler(e) {
//       // 这里判断点击的元素是否是本身，是本身，则返回
//       if (el.contains(e.target)) {
//         return false;
//       }
//       // 判断指令中是否绑定了函数
//       if (binding.expression) {
//         // 如果绑定了函数 则调用那个函数，此处binding.value就是handleClose方法
//         binding.value(e);
//       }
//     }
//     // 给当前元素绑定个私有变量，方便在unbind中可以解除事件监听
//     el.vueClickOutside = documentHandler;
//     document.addEventListener('click', documentHandler);
//   },
//   update() {},
//   unbind(el, binding) {
//     // 解除事件监听
//     document.removeEventListener('click', el.vueClickOutside);
//     delete el.vueClickOutside;
//   },
// };
export default {
  name: "Technocracy",
  data(){
    return{
      form:{
          username:'',
          time:'',
          type:'',
          name:'',
          addr:'',
          lx_user:'',
          tel:'',
          remarks:'',
      },
      types: [{'id': 1, 'type': '检查'}, {'id': 2, 'type': '审查'}, {'id': 3, 'type': '咨询服务'}],
      token:'',
      fileList:[],
      dialogImageUrl: '',
      dialogVisible: false,
      //hideUploadEdit: false, //是否隐藏上传按钮
      fileList1:[],
      dialogImageUrl1: '',
      dialogVisible1: false,
      ruleForm: {
        name:'',
        pic:'',
        img:'',
        introduction:'',
        /*issue:'',*/
      },
      rules: {
        name: [
          {
            required: true,
            message: '请输入姓名',
            trigger: 'blur',
          },
        ],
        introduction_text: [
          {
            required: true,
            message: '请输入简介',
            trigger: 'blur',
          },
        ]
      },
      total:0,//总条目数
      per_page:10,
      current_page:1, //当前页数
      tabPosition: 'left',
      activeName: 'first',
      waytitle:'',
      waycontent:'',
      expertcontent:'',
      expertsList: [
        /*{id:'1',name:'木子李1',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'2',name:'木子李2',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'3',name:'木子李3',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'4',name:'木子李4',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'5',name:'木子李5',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'6',name:'木子李6',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'7',name:'木子李7',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'8',name:'木子李8',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},
        {id:'9',name:'木子李9',content:'关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知关于2021年全国安全文化建设示范企业复审结果的通知',imgurl:'static/images/zhuanjia.png',url:''},*/
      ],
      btnShow: false,
      index:'0',
      replyComment:'',
      nickname:'测试21',
      userid:'1',
      bbsid: '',
      head_img:'http://hg.xltpay.cn/storage/head/20220806/882fa0f6d9acff560a53861b30196af1.jpg',
      myId:19870621,
      to:'啊啊啊',
      toId:-1,
      comments:[
        /*{
          nickname:'Lana Del Rey',
          userid:19870621,
          head_img:'https://ae01.alicdn.com/kf/Hd60a3f7c06fd47ae85624badd32ce54dv.jpg',
          comment:'我发布一张新专辑Norman Fucking Rockwell,大家快来听啊',
          createtime:'2019年9月16日 18:43',
          commentNum:2,
          like:15,
          inputShow:false,
          reply:[
            {
              fromname:'Taylor Swift',
              fromid:19891221,
              fromimg:'https://ae01.alicdn.com/kf/H94c78935ffa64e7e977544d19ecebf06L.jpg',
              to:'Lana Del Rey',
              toId:19870621,
              comment:'我很喜欢你的新专辑！！',
              createtime:'2019年9月16日 18:43',
              commentNum:1,
              like:15,
              inputShow:false
            },
          ]
        },*/
      ],
      /*xzList: [
        {id:'1',title:'专家入库申请表',message:'http://hg.xltpay.cn/storage/apply/20220809/f94af82a872ddd95f8f391a03e4371bb.pdf'},
      ],*/
    }
  },
  // directives: {clickoutside},
  mounted(){
    let that=this;
    Utils.$on('demo', function (msg) {
      if(msg == '8-1'){
        that.activeName = "first";
        that.handleClick(that.activeName)
      }else if(msg == '8-2'){
        that.activeName = "second";
        that.handleClick(that.activeName)
      }else if(msg == '8-3'){
        that.activeName = "third";
        that.handleClick(that.activeName)
      }else if(msg == '8-4'){
        that.activeName = "fourth";
        that.handleClick(that.activeName)
      }else if(msg == '8-5'){
        that.activeName = "fifth";
        that.handleClick(that.activeName)
      }
    });
    let name = sessionStorage.getItem('currentTab')
    // 判断是否存在currentTab，即tab页之前是否被点击切换到别的页面
    if(name){
      this.activeName = name
    }
  },
  beforeRouteLeave(to, from, next){
    // 在离开此路由之后清除保存的状态（我的需求是只需要在当前tab页操作刷新保存状态，路由切换之后不需要保存）
    // 根据个人需求决定清除的时间
    sessionStorage.removeItem('currentTab')
    next()
  },
  created() {
    let a = this.$route.query.act;

    if(a=='second'){
      this.activeName = "second";
      this.handleClick(this.activeName)
    }
    this.way();
    //this.experts();
    this.technocracy();
    this.user();
   // this.expert();
  },
  methods: {
    handleClick(tab) {
      console.log(tab)
      if(tab==='first'){
        this.way();
      }else if(tab==='second'){
        this.experts()
      }else if(tab==='third'){
        //this.performance()
      }else if(tab==='fourth'){
        //this.open()
      }else if(tab==='fifth'){
        this.expert()
      }

      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      //sessionStorage.setItem('currentTab', tab.name)
    },
    handleTabClick(tab) {
      console.log(tab)
      if(tab.name==='first'){
        this.way();
      }else if(tab.name==='second'){
        this.experts()
      }else if(tab.name==='third'){
        //this.performance()
      }else if(tab.name==='fourth'){
       // this.open()
      }else if(tab.name==='fifth'){
        this.expert()
      }
      // 点击tab后触发事件，修改显示页面，将状态保存在sessionStorage里面
      sessionStorage.setItem('currentTab', tab.name)
    },
    onSubmit(){
      if(this.form.username == ''){
        this.$message.error('专家姓名不能为空')
        return
      }else if(this.form.time == ''){
        this.$message.error('参与时间不能为空')
        return
      }else if(this.form.type == ''){
        this.$message.error('项目类型不能为空')
        return
      }else if(this.form.name =='') {
        this.$message.error('项目名称不能为空')
        return
       }else if(this.form.addr == ''){
        this.$message.error('参与地点不能为空')
        return
      }else if(this.form.lx_user == ''){
        this.$message.error('项目方联系人不能为空')
        return
      }
      else if(this.form.tel == ''){
        this.$message.error('项目方电话不能为空')
        return
      }
      //else if(this.form.remarks == ''){
      //   this.$message.error('备注不能为空')
      //   return
      // }
      let params = {
        username: this.form.username,
        time: this.form.time,
        type: this.form.type,
        name:this.form.name,
        addr:this.form.addr,
        lx_user: this.form.lx_user,
        tel:this.form.tel,
        remarks:this.form.remarks,

      }
      this.axios.post('/api/index/addReprot',params).then((response) => {
        console.log(response)
        if(response.data.code == 1){
          this.$message({
            showClose: true,
            type:'success',
            message:'信息报备成功',
            duration:3000
          })

        }else{
          this.$message({
            showClose: true,
            type:'error',
            message:'信息报备失败',
            duration:2000
          })
        }
        this.form={
        username:'',
          time:'',
          type:'',
          name:'',
          addr:'',
          lx_user:'',
          tel:'',
          remarks:'',
      }
      }).catch(function (error) {
        console.log(error)
       });
    },
    cance(){
      this.form={
        username:'',
          time:'',
          type:'',
          name:'',
          addr:'',
          lx_user:'',
          tel:'',
          remarks:'',
      }
    },
    user(){
      let token = sessionStorage.getItem('token')
      if(token){
        this.token = token
      }
      let params = new FormData()
      params.append('token',token)
      this.axios.post('/api/user/userInfo',params).then((response) => {
        if(response.data.msg == 'success'){
          this.userid = response.data.data.id
          this.nickname = response.data.data.nickname
          this.head_img = response.data.data.head_img
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    /*专家管理办法*/
    way(){
      let params = {}
      this.axios.post('/api/index/wayList',params).then((response) => {
        console.log(response)
        if(response.data.msg == 'success'){
          this.waytitle = response.data.data.message
          this.waycontent = response.data.data.value
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    /*专家库*/
    expert(){
      let params = {}
      this.axios.post('/api/index/exList',params).then((response) => {
        console.log(response)
        if(response.data.msg == 'success'){
          this.expertcontent = response.data.data.data[0].introduction
        }
      }).catch(function (error) {
        console.log(error)
      });
    },
    /*核心专家*/
    experts(){
      let params = {}

     //obj = Object.assign(this.queryInfo);
      this.axios.post('/api/index/expertsList',params).then((response) => {
        console.log(response)
         if(response.data.code == 200) {
          this.expertsList = response.data.data.data
          this.total=Number(response.data.data.total)
         }
      }).catch(function (error) {
        console.log(error);
      });

    },
    /*专家论坛*/
    technocracy(){
      let params = {}
      this.axios.post('/api/index/technocracyList',params).then((response) => {
        if(response.data.msg == 'success') {
          this.comments = response.data.data
        }
      }).catch(function (error) {
        console.log(error);
      });
    },

    //监听 pagesize 改变的事件
    size_change(newSize){
      this.per_page = newSize
      this.experts();
    },
    //监听 页码值 改变的事件
    current_change(newPage){
      console.log(newPage)
      this.current_page = newPage

      this.experts();
    },
    inputFocus(){
      var replyInput = document.getElementById('replyInput');
      replyInput.style.padding= "8px 8px"
      replyInput.style.border ="2px solid blue"
      replyInput.focus()
    },
    showReplyBtn(){
      this.btnShow = true
    },
    hideReplyBtn(){
      this.btnShow = false
      replyInput.style.padding= "10px"
      replyInput.style.border ="none"
    },
    showReplyInput(i,name,id,iid){
      this.comments[this.index].inputShow = false
      this.index =i
      this.comments[i].inputShow = true
      this.to = name
      this.toId = id
      this.bbsid = iid
    },
    _inputShow(i){
      return this.comments[i].inputShow
    },
    sendComment(){
      if(this.token == ''){
        this.$router.push({path:'/Login'})
        return
      }
      if(!this.replyComment){
        this.$message({
          showClose: true,
          type:'warning',
          message:'内容不能为空'
        })
      }else{
        let input =  document.getElementById('replyInput')
        /*let timeNow = new Date().getTime();
        let time= this.dateStr(timeNow);*/
        let date = new Date();
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = date.getDate() + ' ';
        let h = date.getHours() + ':';
        let m = date.getMinutes() + ':';
        let s = date.getSeconds();
        let time= Y+M+D+h+m+s;
        let params ={
          userid:this.userid,
          comment:this.replyComment,
          createtime:time,
          inputShow: false
        }
        let conts = {
          nickname : this.nickname,
          to:this.to,
          toid : this.toId,
          userid:this.userid,
          head_img: this.head_img,
          createtime:time,
          comment:this.replyComment,
          inputShow:false
        }
        /*a.like = 0*/
        this.axios.post('/api/index/comment',params).then((response) => {
          if(response.data.msg == '发布成功') {
            this.$message({
              showClose: true,
              type:'success',
              message:response.data.msg,
              duration:2000
            })
            this.comments.push(conts)
            this.replyComment = ''
            input.innerHTML = '';
          }else{
            this.$message({
              showClose: true,
              type:'error',
              message:response.data.msg,
              duration:2000
            })
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    sendCommentReply(i,j){
      if(this.token == ''){
        this.$router.push({path:'/Login'})
        return
      }
      if(!this.replyComment){
        this.$message({
          showClose: true,
          type:'warning',
          message:'评论不能为空'
        })
      }else{
        let input =  document.getElementById('replyInput')
        /*let timeNow = new Date().getTime();
        let time= this.dateStr(timeNow);*/
        let date = new Date();
        let Y = date.getFullYear() + '-';
        let M = (date.getMonth()+1 < 10 ? '0'+(date.getMonth()+1) : date.getMonth()+1) + '-';
        let D = date.getDate() + ' ';
        let h = date.getHours() + ':';
        let m = date.getMinutes() + ':';
        let s = date.getSeconds();
        let time= Y+M+D+h+m+s;
        let params ={
          bbsid:this.bbsid,
          fromid:this.userid,
          toid: this.toId,
          comment :this.replyComment,
          createtime:time,
          inputShow: false
        }
        let coms = {
          toid : this.toId,
          fromname : this.nickname,
          nickname : this.to,
          fromimg : this.head_img,
          comment : this.replyComment,
          createtime : time,
          commentNum : 0,
        }

        this.axios.post('/api/index/commentreply',params).then((response) => {
          if(response.data.msg == '发布成功') {
            this.$message({
              showClose: true,
              type:'success',
              message:response.data.msg,
              duration:2000
            })
            this.comments[i].reply.push(coms)
            this.replyComment = ''
            document.getElementsByClassName("reply-comment-input")[i].innerHTML = ""
          }else{
            this.$message({
              showClose: true,
              type:'error',
              message:response.data.msg,
              duration:2000
            })
          }
        }).catch(function (error) {
          console.log(error);
        });
      }
    },
    onDivInput: function(e) {
      this.replyComment = e.target.innerHTML;
    },
    dateStr(date){
      //获取js 时间戳
      var time=new Date().getTime();
      //去掉 js 时间戳后三位，与php 时间戳保持一致
      time=parseInt((time-date)/1000);
      //存储转换值
      var s;
      if(time<60*10){//十分钟内
        return '刚刚';
      }else if((time<60*60)&&(time>=60*10)){
        //超过十分钟少于1小时
        s = Math.floor(time/60);
        return  s+"分钟前";
      }else if((time<60*60*24)&&(time>=60*60)){
        //超过1小时少于24小时
        s = Math.floor(time/60/60);
        return  s+"小时前";
      }else if((time<60*60*24*30)&&(time>=60*60*24)){
        //超过1天少于30天内
        s = Math.floor(time/60/60/24);
        return s+"天前";
      }else{
        //超过30天ddd
        var date= new Date(parseInt(date));
        return date.getFullYear()+"/"+(date.getMonth()+1)+"/"+date.getDate();
      }
    },
    canelCommit(i) {
      this.comments[i].inputShow = false
    },


    //上传图片的方法
    UploadImage(file,filelist) {
      let token = sessionStorage.getItem("token")
      let fd = new FormData()
      fd.append('file', file.raw) //传给后台接收的名字 file
      fd.append('token',token)
      let isLtXM = file.raw.size / 1024 / 1024 < 3
      if(!isLtXM) {
        this.$message({
          message: '申请表不能超过 3MB!',
          type: 'warning'
        });
        return
      }
      if(file.raw.type == 'image/jpeg' || file.raw.type == 'image/jpg' || file.raw.type == 'image/png'){
        axios.post('/api/upload/uploadHead', fd, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
          if(response.data.code == 1){
            this.ruleForm.pic = response.data.data.url;
            this.$router.push({path:'/Technocracy'})
          }
        })
      }else{
        axios.post('/api/upload/uploadPdf', fd, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
          if(response.data.code == 1){
            this.ruleForm.pic = response.data.data.url;
            this.$router.push({path:'/Technocracy'})
          }
        })
      }
    },
    //移除图片功能
    handleRemove(file, fileList) {
    },
    //上传图片的方法
    UploadImage1(file,filelist) {
      let fd = new FormData()
      fd.append('file', file.raw) //传给后台接收的名字 file
      fd.append('token',sessionStorage.getItem("token"))
      let isLtXM = file.raw.size / 1024 / 1024 < 2
      if(!isLtXM) {
        this.$message({
          message: '头像不能超过 2MB!',
          type: 'warning'
        });
        return
      }
        axios.post('/api/upload/uploadHead', fd, {headers: {'Content-Type': 'multipart/form-data'}}).then(response => {
          if(response.data.code == 1){
            this.ruleForm.img = response.data.data.url;
            this.$router.push({path:'/Technocracy'})
          }
        })
    },
    //移除图片功能
    handleRemove1(file, fileList) {
    },
    //添加
    submitForm(formName) {
      let ruleForm =this.ruleForm
      let token = sessionStorage.getItem('token')
      let params = new FormData()
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if(this.ruleForm.img == '' && this.ruleForm.pic == ''){
            return false
          }
          params.append('token',token)
          params.append('pic',this.ruleForm.pic)
          params.append('img',this.ruleForm.img)
          params.append('introduction',this.ruleForm.introduction)
          params.append('name',this.ruleForm.name)
          axios.post('/api/user/expert_apply',params).then(response => {
            if (response.data.code == 1){
              this.$message({
                showClose: true,
                type:'success',
                message:'申请成功',
                duration:2000
              })
              this.resetForm(formName)
            }
          }).catch(function (error) {
            console.log(error)
          });
        } else {
          return false
        }
      })
    },
    //提交后重置上传界面表单
    resetForm(formName) {
      this.$refs.uploadimg.clearFiles()
      this.$refs.upload.clearFiles()
      this.$refs[formName].resetFields()
    },
    /*handleExport(url){
      window.open(url)
    },*/
    /*handleExport(id,filename,ty) {
      axios({
        method: 'get',
        url: '/api/index/downloadExcel', // 请求地址
        params: {"id":id}, // 参数
        responseType: 'blob', // 表明返回服务器返回的数据类型
        headers:{
          'Content-type':'pplication/json;charset=UTF-8'
        }
      }).then((res) => {
        let type = '';
        let type2 = [];
        if(ty == 'doc'){
          type = "application/msword"
          type2 = ['.doc','.docx']
        }else if(ty == 'pdf'){
          type = "application/pdf"
          type2 = ['.pdf']
        }else{
          type = "application/vnd.ms-excel"
          type2 = ['.xls',',xlsx']
        }
        const link = document.createElement('a')
        let blob = new Blob([res.data], {type})
        link.style.display = 'none'
        link.href = URL.createObjectURL(blob)
        link.download = filename
        link.type = type2
        document.body.appendChild(link)
        link.click()
        window.URL.revokeObjectURL(link.href)
        document.body.removeChild(link)
      }).catch(error=>{
      })
    },*/
  }
}
</script>

<style scoped>
.upimg{
  text-align: left;
  padding-left: 63px;
}
.upimg /deep/ .el-upload--picture-card {
  width: 50px;
  height: 50px;
}
.upimg /deep/ .el-upload-list__item {
  width: 50px;
  height: 50px;
}
.upapply{
  text-align: left;
  padding-left: 63px;
}
.hide >>> .el-upload--picture-card {
  display: none;
}

.xh >>>.el-tabs__nav-wrap::after {
  position: static !important;
}
.xh >>>.el-tabs__active-bar {
  background-color: transparent !important;
}
.im{
   /* width:10%; */
  /* float: left; */
  width: 105px;
  height: 140px;
}
.pi{
  /* float: left; */
  width: 75%;
  /* height: 90px; */
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 5;
  text-align: justify;
  text-align: left;
  padding: 0 20px;
  line-height: 27px;
}
a {
  text-decoration: none;
  color: black;
}
.my-reply{
  padding: 10px;
  background-color: #fafbfc;
}
.header-img{
  display: inline-block;
  vertical-align: top;
}
.reply-info{
  display: inline-block;
  margin-left: 5px;
  width: 90%;
}
.reply-input{
  min-height: 20px;
  line-height: 22px;
  padding: 10px 10px;
  color: #ccc;
  background-color: #fff;
  border-radius: 5px;
}
.reply-btn-box{
  height: 25px;
  margin: 10px 0px;
}
.reply-btn{
  position: relative;
  float: left;
  margin-right: 15px;
}
.my-comment-reply{
  margin-left: 50px;
}
.reply-input{

}
.author-title:not(:last-child){
  border-bottom: 1px solid rgba(178,186,194,.3);
}
.author-title{
  padding: 10px;
}
.header-img{
  display: inline-block;
  vertical-align: top
}
.author-info{
  display: inline-block;
  margin-left: 5px;
  width: 60%;
  height: 40px;
  line-height: 20px;
}
.author-info span{
  display: block;
  cursor: pointer;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  text-align: left;
}
.author-name{
  color: #000;
  font-size: 18px;
  font-weight: bold;
}
.author-time{
  font-size: 14px;
}
.icon-btn{
  width: 30%;
  padding: 0 !important;
  float: right;
}
.icon-btn span{
  cursor: pointer
}
.iconfont{
  margin: 0 5px
}
.talk-box{
  margin: 0 50px
}
.talk-box p{
  margin: 0;
  text-align: left;
}
.reply{
  font-size: 16px;
  color: #000;
  text-align: center;
}
.reply-box{
  margin: 10px 0 0 50px;
  background-color: #efefef
}
.pa /deep/ p{
  margin-top: 0px;
  margin-bottom: 0px;
}
</style>



// WEBPACK FOOTER //
// src/components/view/Technocracy.vue